export enum ODataType {
  string = "string",
  guid = "guid",
  int = "int",
  decimal = "decimal",
  datetime = "datetime",
  raw = "raw",
}
